import React from "react";
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";
import Button from "balkerne-components/Button";
import Badge from "balkerne-components/Badge";
import Select from "balkerne-components/Select";
import Input from "balkerne-components/Input";
import Card from "react-bootstrap/Card";
import c from "./AssignUsers.module.scss";

export class AssignUsersSingle extends React.Component {
  constructor(props) {
    super(props);
    //setting TEMPORARY STATE
    this.state = {
      users: this.props.users,
      addUsers: [],
      filter_string: "",
      filter_type: "",
      filteredLocations: null,
      selectedLocations: [],
      selectedUsers: [],
      selectedAddUsers: [],
      ctrl: false,
      shifts: false,
      lastIndexLocation: 0,
      lastIndexUsers: 0,
      lastIndexAddUsers: 0,
      loaded: false,
      event_message:"Assigning properties to a single user."
    };
  }

  componentDidMount() {
    document.addEventListener("keydown", this.handleKeyDown);
    document.addEventListener("keyup", this.handleKeyUp);
  }
  componentWillUnmount() {
    document.removeEventListener("keydown", this.handleKeyDown);
    document.removeEventListener("keyup", this.handleKeyUp);
  }

  applyFilter = () => {
    this.state.filteredLocations = this.props.locations;
    let filteredLocations;
    switch (this.state.filter_type) {
      case "Name":
        filteredLocations = this.props.locations.filter((location) => {
          if (location.name) {
            return location.name
              .toLowerCase()
              .includes(this.state.filter_string.toLowerCase());
          }
        });
        break;
      case "Region":
        filteredLocations = this.props.locations.filter((location) => {
          if (location.region) {
            return location.region
              .toLowerCase()
              .includes(this.state.filter_string.toLowerCase());
          }
        });
        break;
      case "CRN":
        filteredLocations = this.props.locations.filter((location) => {
          if (location.property_customer_reference) {
            return location.property_customer_reference
              .toLowerCase()
              .includes(this.state.filter_string.toLowerCase());
          }
        });
        break;
      case "Address":
        filteredLocations = this.props.locations.filter((location) => {
          if (location.address_street) {
            return location.address_street
              .toLowerCase()
              .includes(this.state.filter_string.toLowerCase());
          }
        });
        break;
      case "Postcode":
        filteredLocations = this.props.locations.filter((location) => {
          if (location.address_postcode) {
            return location.address_postcode
              .toLowerCase()
              .includes(this.state.filter_string.toLowerCase());
          }
        });
        break;
      default:
        filteredLocations = this.props.locations;
    }

    this.setState({ filteredLocations });
  };

  clearFilter = () => {
    this.state.filter_string = "";

    let filteredLocations = this.props.locations;

    this.setState({ filteredLocations });
  };

  handleKeyDown = (event) => {
    if (event.ctrlKey) {
      this.state.ctrl = true;
    }
    if (event.shiftKey) {
      this.state.shift = true;
    }
  };

  handleKeyUp = (event) => {
    if (event.keyCode === 17) {
      this.state.ctrl = false;
    }
    if (event.keyCode === 16) {
      this.state.shift = false;
    }
  };

  handleChange = (e) => {
    let filter = {};
    filter[e.target.name] = e.target.value;
    this.setState(filter);
    //this.props.handleChange("users",this.state.users);
  };

  setCtrl = (press) => {
    this.state.ctrl = press;
  };

  setShift = (press) => {
    this.state.shift = press;
  };

  onRowSelectLocations = (row, isSelected, e, rowIndex) => {
    if (
      this.state.ctrl ||
      (this.state.users &&
        this.props.users.length === 1 &&
        (this.props.users[0].role === "Property Manager" ||
          this.props.users[0].role === "Property Admin"))
    ) {
      if (isSelected) {
        this.state.selectedLocations = [row.id];
      } else {
        this.state.selectedLocations = [row.id];
      }
      let message =
      "The user is assigned to " +
      this.state.selectedLocations.length +
      " properties.";
    this.setState({ event_message: message });
    } else if (
      this.state.shift &&
      !(
        this.state.users &&
        this.props.users.length === 1 &&
        (this.props.users[0].role === "Property Manager" ||
          this.props.users[0].role === "Property Admin")
      )
    ) {
      if (isSelected) {
        document.getSelection().removeAllRanges();
        if (this.state.lastIndexLocation > rowIndex) {
          for (let i = rowIndex; i <= this.state.lastIndexLocation; i++) {
            if (
              !this.state.selectedLocations.includes(
                this.state.filteredLocations[i].id
              )
            ) {
              this.state.selectedLocations.push(
                this.state.filteredLocations[i].id
              );
            }
          }
        } else {
          for (let i = this.state.lastIndexLocation; i <= rowIndex; i++) {
            if (
              !this.state.selectedLocations.includes(
                this.state.filteredLocations[i].id
              )
            ) {
              this.state.selectedLocations.push(
                this.state.filteredLocations[i].id
              );
            }
          }
        }
        let message =
        "The user is assigned to " +
        this.state.selectedLocations.length +
        " properties.";
      this.setState({ event_message: message });
      }
    } else {
      if (isSelected) {
        if (
          !(
            this.props.users &&
            this.props.users.length === 1 &&
            (this.props.users[0].role === "Property Manager" ||
              this.props.users[0].role === "Property Admin") &&
            this.state.selectedLocations &&
            this.state.selectedLocations.length > 0
          )
        ) {
          this.state.selectedLocations.push(row.id);
        } else {
          console.log(
            "Can only select a single property for single property users."
          );
        }
      } else {
        console.log(
          this.state.selectedLocations.findIndex((location) => {
            return location === row.id;
          }, 1)
        );
        this.state.selectedLocations.splice(
          this.state.selectedLocations.findIndex((location) => {
            return location === row.id;
          }),
          1
        );
      }
      let message =
      "The user is assigned to " +
      this.state.selectedLocations.length +
      " properties.";
    this.setState({ event_message: message });
    }

    this.props.updateSelectedLocations(this.state.selectedLocations);

    if (isSelected) {
      this.state.lastIndexLocation = rowIndex;
    }

    // // RESET SELECTED ADD USERS
    // if (this.state.selectedLocations && this.state.selectedLocations.length !== 1) {
    //   let selectedAddUsers = []
    //   this.setState({ selectedAddUsers })

    //   this.props.updateSelectedAddUsers(selectedAddUsers)
    //}
  };

  selectAllProperties = (select) => {
    if (
      this.props.users &&
      this.props.users.length === 1 &&
      (this.props.users[0].role != "Property Manager" &&
        this.props.users[0].role != "Property Admin")
    ) {
      if (select) {
        for (let i = 0; i < this.state.filteredLocations.length; i++) {
          if (
            !this.state.selectedLocations.includes(
              this.state.filteredLocations[i].id
            )
          ) {
            this.state.selectedLocations.push(
              this.state.filteredLocations[i].id
            );
          }
        }

        this.props.updateSelectedLocations(this.state.selectedLocations);
        
      let message =
      "The user is assigned to " +
      this.state.selectedLocations.length +
      " properties.";
    this.setState({ event_message: message });


      } else {
        let selectedLocations = [];
        this.setState({ selectedLocations });

        this.props.updateSelectedLocations(selectedLocations);

      let message =
      "The user is assigned to " +
      "0" +
      " properties.";
    this.setState({ event_message: message });

      }
    } else {
      console.log(
        "Can only select a single property for single property users."
      );
      this.setState({ event_message: "Can only select a single property for single property users." });

      let selectedLocations = [];
        this.setState({ selectedLocations });

        this.props.updateSelectedLocations(selectedLocations);
    }

    // // RESET SELECTED ADD USERS
    // if (this.state.selectedLocations && this.state.selectedLocations.length !== 1) {
    //   let selectedAddUsers = []
    //   this.setState({ selectedAddUsers })

    //   this.props.updateSelectedAddUsers(selectedAddUsers)
    //}
  };

  resetChanges = () => {
    let selectedLocations = [];
    this.setState({ selectedLocations });
    this.props.updateSelectedLocations(selectedLocations);

    this.props.resetChanges();
  };

  render() {
    if (this.props.currentStep !== 2) {
      return null;
    }

    
    let selectRowPropLocations = {
      mode: "checkbox",
      clickToSelect: true,
      bgColor: "var(--focus-background)",
      selected: this.state.selectedLocations,
      // hideSelectColumn: true,
      onSelect: this.onRowSelectLocations,
      onSelectAll: this.selectAllProperties,
    };
    

    if (
      this.state.loaded === false &&
      this.props.locations &&
      this.props.locations.length
    ) {
      this.state.filteredLocations = this.props.locations;
      this.state.loaded = true;
    }

    if (this.state.filteredLocations === null) {
      this.state.filteredLocations = this.props.locations;
    }
    
   

    return (
      <div className="d-flex flex-column flex-gap-3">
        <div className="d-flex flex-column flex-gap-1">
          {/* Property filters */}
          <Card>
            <Card.Body>
              <form onChange={this.handleChange} className={c.controls}>
                <Input
                  label="Filter"
                  id="filter_string"
                  name="filter_string"
                  value={this.state.filter_string}
                />
                <Select
                  id="filter_type"
                  label="Category"
                  onChange={({ value }) =>
                    this.handleChange({
                      target: {
                        value: value,
                        name: "filter_type",
                      },
                    })
                  }
                  options={[
                    { value: "Name", label: "Name" },
                    { value: "Region", label: "Region" },
                    { value: "CRN", label: "CRN" },
                    { value: "Address", label: "Address" },
                    { value: "Postcode", label: "Postcode" },
                  ]}
                />
                <Button light onClick={this.applyFilter}>
                  Apply
                </Button>
                <Button light onClick={this.clearFilter}>
                  Clear
                </Button>
              </form>
              
            </Card.Body>
          </Card>

          <div className="d-flex justify-content-center">
            <span>{this.state.event_message}</span>
          </div>

          {/* All existing properties */}
          <Card>
            <Card.Header>
              <h4>
                Select Properties (Ctrl + Left click) you'd like to add users to
              </h4>
            </Card.Header>
            <div className={c.portfolio}>
              <BootstrapTable
                selectRow={selectRowPropLocations}
                data={this.state.filteredLocations}
                striped
                hover
              >
                <TableHeaderColumn width="0%" isKey dataField="id" hidden>
                  ID
                </TableHeaderColumn>
                <TableHeaderColumn width="25%" dataField="name">
                  Property Name
                </TableHeaderColumn>
                <TableHeaderColumn width="30%" dataField="address_street">
                  Address
                </TableHeaderColumn>
                <TableHeaderColumn width="15%" dataField="address_postcode">
                  Postcode
                </TableHeaderColumn>
                <TableHeaderColumn width="15%" dataField="region">
                  Region
                </TableHeaderColumn>
                <TableHeaderColumn
                  width="15%"
                  dataField="property_customer_reference"
                >
                  Property Reference
                </TableHeaderColumn>
              </BootstrapTable>
            </div>
          </Card>
        </div>
      </div>
    );
  }
}

export default AssignUsersSingle;
